import Store from './Store';
const QRCode = require('qrcode');
// Some categories might be wanted to combine and used together.
// Following keys will be taken from CMS to filter category name.
const MultiCategoryKeys = {
  Lipstick_Lippencil: 'Lipstick_Lippencil',
};

const TemplateFieldTypes = {
  COLOR: 'color',
  TEXT: 'text',
  HOVER: 'hover',
  SWITCH_BRAND: 'switchBrand',
  SWITCH_ARROW: 'switchArrow',
  CATEGORIES: 'categories',
};

const TemplateColorFieldPropertTypes = {
  COLOR: 'color',
  BACKGROUND_COLOR: 'background-color',
  BORDER_COLOR: 'border-color',
};

export const TemplateFields = {
  themeColor: {
    classname: '.product.active',
    type: TemplateFieldTypes.COLOR,
    style: TemplateColorFieldPropertTypes.BORDER_COLOR,
  },
  textColor: {
    classname: '#container',
    type: TemplateFieldTypes.COLOR,
    style: TemplateColorFieldPropertTypes.COLOR,
  },
  arrowsEnable: {
    classname: '.categories',
    type: TemplateFieldTypes.SWITCH_ARROW,
  },
  brandEnable: {
    mainClassName: '.brands-container',
    secondClassName: '.categories-container',
    type: TemplateFieldTypes.SWITCH_BRAND,
  },
  brandTitle: { classname: '.main-brand-text', type: TemplateFieldTypes.TEXT },
  categoryTitle: { classname: '.main-category-text-cib', type: TemplateFieldTypes.TEXT },
  productFamilyTitle: { classname: '.main-product-text-cib', type: TemplateFieldTypes.TEXT },
  colorTitle: { classname: '.main-color-text-cib', type: TemplateFieldTypes.TEXT },
  addToCartText: { classname: '.add-cart-btn', type: TemplateFieldTypes.TEXT },
  goToProductText: { classname: '.go-product-btn', type: TemplateFieldTypes.TEXT },
  buttonsBorderColor: {
    classname: '.add-cart-btn, .go-product-btn, .all-product-qr',
    type: TemplateFieldTypes.COLOR,
    style: TemplateColorFieldPropertTypes.BORDER_COLOR,
  },
  buttonsBackgroundColor: {
    classname: '.add-cart-btn, .go-product-btn, .all-product-qr',
    type: TemplateFieldTypes.COLOR,
    style: TemplateColorFieldPropertTypes.BACKGROUND_COLOR,
  },
  buttonsTextColor: {
    classname: '.add-cart-btn, .go-product-btn, .all-product-qr',
    type: TemplateFieldTypes.COLOR,
    style: TemplateColorFieldPropertTypes.COLOR,
  },
  buttonsHoverActionColor: {
    classname: '.add-cart-btn, .go-product-btn, .all-product-qr',
    type: TemplateFieldTypes.HOVER,
  },
  categories: { classname: '.categories', type: TemplateFieldTypes.CATEGORIES },
};

export const Breakpoints = {
  WIDE_TABLET: 998,
};

export const CountlyMethods = {
  ADD_TO_CART: { key: 'addToCart' },
  GO_TO_PRODUCT: { key: 'goToProduct' },
  FEATURED_LOOKS: { key: 'featuredLooks' },
};

const CollectActions = {
  ADD_TO_CART: 'add_to_cart',
  GO_TO_PRODUCT: 'product_url',
};

const SINGLE_MAKEUP_MODE = 'single_vto';

/**
 * Latest iOS devices (starting from iOS 12) has ""Macintosh" as userAgant,
 * but not "iPad/iPhone". Mac laptops also have the same userAgent,
 * so checking touch points is needed to separete Mac laptop from iOS devices.
 * @returns {boolean} - Whether it is an iOS device or not.
 */
const checkLatestiOSDevices = () =>
  (/Mac/.test(navigator.platform) || /Mac/.test(navigator.userAgent)) &&
  navigator.maxTouchPoints &&
  navigator.maxTouchPoints > 2;

/**
 * Detect whether it is a mobile device or not.
 * @returns {boolean} - Whether it is a mobile device or not.
 */
export const checkIsMobile = () => {
  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      navigator.userAgent,
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      navigator.userAgent.substr(0, 4),
    ) ||
    checkLatestiOSDevices()
  ) {
    return true;
  }
  return false;
};

/**
 * Create GTM tracker script tag with given GTM ID.
 * @param {string} gtmId - Google Tag Manager ID.
 * @returns {Function} - Google Tag Manager loader script.
 */
const getDefaultGtmScript = (gtmId) =>
  (function (window, document, scriptTag, dataLayerKey, gtmId) {
    window[dataLayerKey] = window[dataLayerKey] || [];
    window[dataLayerKey].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const containerElement = document.getElementsByTagName(scriptTag)[0],
      scriptToLoad = document.createElement(scriptTag),
      dataLayerToTrack = dataLayerKey != 'dataLayer' ? '&l=' + dataLayerKey : '';
    scriptToLoad.async = true;
    scriptToLoad.src = 'https://www.googletagmanager.com/gtm.js?id=' + gtmId + dataLayerToTrack;
    containerElement.parentNode.insertBefore(scriptToLoad, containerElement);
  })(window, document, 'script', 'dataLayer', gtmId);

/**
 * Append the GTM script to the head of the document if the GTM ID is provided.
 */
export const addGtmScript = () => {
  const gtmId = checkIsMobile() ? $('.gtm_mobile_id').val() : $('.gtm_id').val();
  if (!gtmId || gtmId === 'false') return;

  $('head').append(`<script>${getDefaultGtmScript(gtmId)}<\/script>`);
};

/**
 * There are supposed to be two buttons under the plugin in Web.
 * If the active product matches the param types, show the necessary buttons.
 * @param {string} activeColorID - Unique ID of selected product to find the product.
 * @param {string} goProductSelector - jQuery selector for the element.
 * @param {string} addCartSelector - jQuery selector for the element.
 */
export const toggleProductButtons = ({
  activeColorID,
  goProductSelector,
  addCartSelector,
  productQRSelector,
  addCartWrapper,
}) => {
  const activeProduct = pulpo.products.filter((product) => product.id == activeColorID);
  const productURL = activeProduct[0].dynamic_param_ids.filter(
    (param) =>
      param.website_id == pulpo.Keys.websiteID &&
      (param.type == 'product_url' || param.type == 'deep_link'),
  );
  // Show or hide the button whether it exists for the active product.
  if (productURL.length) {
    $(goProductSelector).addClass('active');
  } else {
    $(goProductSelector).removeClass('active');
  }

  const cartAction = activeProduct[0].dynamic_param_ids.filter(
    (param) => param.website_id == pulpo.Keys.websiteID && param.type == 'cart_action',
  );
  // Show or hide the button whether it exists for the active product.
  if (cartAction.length) {
    $(addCartSelector).addClass('active');
    $(addCartWrapper).addClass('active');
    $(productQRSelector).addClass('active');
  } else {
    $(addCartSelector).removeClass('active');
    $(addCartWrapper).removeClass('active');
  }
};

/**
 * We need to clear the HTML and destroy the pre-existing carousels
 * to build a brand new carousel out of the user selection.
 * It will destroy Owl or Slick depending on the template type.
 * @param {string} selector - jQuery selector of the element.
 */
export const destroyExistingOwl = (selector) => {
  if (pulpo.isCibTemplate || pulpo.isLooksTemplate) {
    destroyExistingSlick(selector);
    return;
  }

  $(selector).html('');
  $(selector).trigger('destroy.owl.carousel');
  $(selector).find('.owl-stage-outer').children().unwrap();
  $(selector).removeClass('owl-center owl-loaded owl-text-select-on');
};

/**
 * We need to clear the HTML and destroy the pre-existing carousels
 * to build a brand new carousel out of the user selection.
 * @param {string} selector - jQuery selector of the element.
 */
export const destroyExistingSlick = (selector) => {
  if (!$(selector).hasClass('slick-slider')) {
    return;
  }

  $(selector).slick('unslick');
  $(selector).html('');
  $(selector).removeClass('slick-initialized slick-slider');
};

/**
 * Group products by their name and assign corresponding elements to the DOM.
 * @param {string} container - jQuery selector of the element.
 * @param {Array} categoryProducts - Products array.
 */
export const assignCategoryProducts = ({ container, categoryProducts }) => {
  const groupedProductsByName = categoryProducts.reduce(function (r, a) {
    r[a.name] = r[a.name] || [];
    r[a.name].push(a);
    return r;
  }, Object.create(null));

  for (const product of Object.values(groupedProductsByName)) {
    product.sort((a, b) => a.color_code - b.color_code);
    const activeElem = product[0];
    $(container).append(
      `<li class="product item" data-code="${activeElem.uid}" data-category="${activeElem.categ_id[1]}"
      data-id="${activeElem.id}" data-color-name="${activeElem.color_name}" data-hdri="${activeElem.hdri_url}">
        <img src="${activeElem.product_image_url}" alt="" class="product-image">
        <div class="product-name">${activeElem.name}</div>
      </li>`,
    );
  }
};

/**
 * Append colors of given product list to the colors container selector.
 * @param {Array} productList - Products array.
 * @param {string} productName - The name of the product family.
 * @param {string} productCategory - Category name of the product.
 * @param {string} colorsContainer - jQuery selector of element.
 */
export const assignProductColors = ({
  productList,
  productName,
  productCategory,
  colorsContainer,
}) => {
  if (pulpo.null_product_active) {
    productList.unshift({ class: 'null-product', ar_color: 'unset' });
  }
  for (const product of productList) {
    $(colorsContainer).append(
      `<li class="color ${product.class || ''}"
        data-product-image="${product.product_image_url}"
        data-product-name="${productName}"
        data-category="${productCategory}"
        data-id="${product.id}"
        data-color-name="${product.color_name}"
        data-product-code="${product.uid}"
        data-hdri="${product.hdri_url}">
        <div class="ar-color" style="background-color: ${product.ar_color};" />
       </li>`,
    );
  }
};

/**
 * Contains the boilerplate codes to apply product with necessary values.
 * @param {string} productCategory - Brand and category name of the product.
 * @param {string} productCode - Product code of the product.
 * @param {string} productColor - Color name of the product.
 * @param {string} productName - Name of the product.
 * @param {number} productId - Unique id of product.
 * @param {string|undefined} hdriUrlForGlass - HDRI url to apply as glass variant.
 */
export const applySelectedProduct = ({
  productCategory,
  productCode,
  productColor,
  productName,
  pluginSelector = 'nailpolishView',
  productId,
  hdriUrlForGlass,
}) => {
  const categoryName = productCategory.split('/')[1].replace(/\s/g, '');

  if (categoryName.toLowerCase().includes('nail')) {
    pulpoInjections.applyNailpolishProduct(
      productCategory.split('/')[0] + `${productName} ${productColor}`,
      pluginSelector,
    );
    // Added for Plugin v2 implementation.
    pulpoInjections.applyNailpolishWithCategoryKey({
      category: categoryName,
      key: productCategory.split('/')[0] + `${productName} ${productColor}`,
      isNail: true,
      pluginSelector,
    });
    return;
  }

  if (categoryName.toLowerCase().includes('eyeglass')) {
    pulpoInjections.applyEyeglassesWithUrl({
      productId,
      objectUrl: productCode,
      hdriUrl: hdriUrlForGlass,
    });
    return;
  }

  if (!productCode) {
    pulpoInjections.applyProduct(
      categoryName,
      productCategory.split('/')[0] + `${productName} ${productColor}`,
    );
    return;
  }

  document.getElementById('makeupView').contentWindow.postMessage(
    JSON.stringify({
      applyProductWithCode: {
        product_code: productCode,
      },
    }),
    '*',
  );
};

/**
 * Filter categories by brand and return only matched ones.
 * @param {Array} allCategories - All categories coming from NodeJS.
 * @param {Array} brandCategories - Category list by unique brand names.
 * @returns {Array} - Filtered category list for certain brand.
 */
export const filterCategoriesByBrand = (allCategories, brandCategories) => {
  const matchedCategories = [];
  for (const category of allCategories) {
    if (brandCategories.find((brandCategory) => brandCategory.includes(category.name))) {
      matchedCategories.push(category);
    }
  }
  return matchedCategories;
};

/**
 * We clear the category elements after brand selection,
 * assign them back to the DOM with filtered categories.
 * @param {string} container - jQuery selector of the element.
 * @param {Array} categoryList - Filtered categories.
 */
export const assignCategories = ({ container, categoryList }) => {
  for (const category of categoryList) {
    $(container).append(
      ' <li class="category item" data-name="' +
        category.name +
        '"><img src="' +
        category.image +
        '" alt="' +
        category.visible_name +
        '" class="category-image"><span class="category-name">' +
        category.visible_name +
        '</span></li>',
    );
  }
};

/**
 * We clear the category elements after brand selection,
 * assign them back to the DOM with filtered categories.
 * It creates either Owl or Slick carousel by Template type.
 */
export const makeCategoriesOwl = () => {
  if (pulpo.isCibTemplate) {
    makeCategoriesSlick();
    return;
  } else if (pulpo.isLooksTemplate) {
    makeLooksCategorySlick('.categories');
    return;
  }

  $('.categories').owlCarousel({
    loop: false,
    margin: 40,
    responsiveClass: true,
    pagination: false,
    dots: false,
    nav: true,
    navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
    responsive: {
      0: {
        items: 3,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 6,
      },
    },
  });
};

/**
 * Creates carousel out of categories in Slick.
 */
const makeCategoriesSlick = () => {
  $('.categories').slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    swipeToSlide: true,
    nextArrow: '<i class="fas fa-chevron-right"></i>',
    prevArrow: '<i class="fas fa-chevron-left"></i>',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
};

/**
 * Creates either Owl or Slick carousel by Template type.
 */
export const makeBrandsOwl = () => {
  if (pulpo.isCibTemplate) {
    makeBrandsSlick();
    return;
  }

  $('.brands').owlCarousel({
    loop: false,
    margin: 17,
    pagination: false,
    dots: false,
    nav: true,
    navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
    autoWidth: true,
    responsive: {
      576: {
        margin: 20,
      },
    },
  });
};

/**
 * Creates carousel out of brands in Slick.
 */
const makeBrandsSlick = () =>
  $('.brands').slick({
    infinite: false,
    variableWidth: true,
    slidesToScroll: 1,
    slidesToShow: 5,
    swipeToSlide: true,
    nextArrow: '<i class="fas fa-chevron-right"></i>',
    prevArrow: '<i class="fas fa-chevron-left"></i>',
    // Slick has issues with "variableWidth" property.
    // We need to implement this in the future: https://github.com/kenwheeler/slick/pull/2635
    responsive: [
      {
        breakpoint: 940,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 430,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

/**
 * We want the plugin to have around 1 / 1.2 aspect-ratio.
 * But Safari does not support it in pure css, handle it here manually.
 * @param {number} bufferWidth - Number to add on height of the iframe.
 * @param {boolean} shouldAddTopMargin - To decide whether add margin-top to the iframe.
 */
export const setPluginAspectRatio = ({ bufferWidth, shouldAddTopMargin = false }) => {
  const pulpoFrameWidth = $('.plugin-wrapper .pulpoFrame').width();
  $('.plugin-wrapper .pulpoFrame').height(pulpoFrameWidth + bufferWidth);
  $('.plugin-wrapper .loader').height(pulpoFrameWidth + bufferWidth);
  $('.plugin-wrapper .loader').width($('.plugin-wrapper').width());

  if (shouldAddTopMargin) {
    // Keep the plugin at the same position with selections wrapper
    // while shrinking it in small devices. 600 is the default height.
    $('.plugin-wrapper').css('margin-top', (600 - pulpoFrameWidth) / 2);
  }
};

/**
 * We want the plugin container to have around 1 / 1.2 aspect-ratio.
 * But Safari does not support it in pure css, handle it here manually.
 * @param {number} bufferWidth - Number to add on height of the iframe.
 * @param {boolean} shouldAddTopMargin - To decide whether add margin-top to the iframe.
 */
export const setPluginContainerAspectRatio = ({ bufferWidth, shouldAddTopMargin = false }) => {
  const pulpoFrameWidth = $('.pulpoFrame').width();
  const buttonsHeight = $('.dynamic-btn-desktop').height();
  // Do not update the height of iframe, it will be updated by the plugin.
  // Direct updates to the iframe height will cause the changes to iframe when parent set new height.
  $('.plugin').height(pulpoFrameWidth + bufferWidth + buttonsHeight);

  if (shouldAddTopMargin) {
    // Keep the plugin at the same position with selections wrapper
    // while shrinking it in small devices. 600 is the default height.
    $('.plugin').css('margin-top', (600 - pulpoFrameWidth) / 2);
  }
};

const doubleCurlyBracesRegex = /{{(([^}][^}]?|[^}]}?)*)}}/gim;
/**
 * If product name contains double curlies both at the start and end,
 * it means a palette product, and we do not want to show palette product names.
 * @param {string} productName - Name of the product.
 * @param {string} selector - jQuery selector of the element.
 */
export const hidePaletteProductName = (productName, selector) => {
  if (productName.toString().match(doubleCurlyBracesRegex)) {
    $(selector).addClass('hidden');
    return;
  }
  $(selector).removeClass('hidden');
};

/**
 * QR queries might have specific params to manipulate QR Page elements.
 * Call "updateQrPage" function with filtered params by QR type.
 * @param {string} key - Represent the name of query (categoryQr - seriesQr - productQr).
 * @param {Object} paramsData - Object containing QR params.
 * @param {string} productsData - Products list based on the QR.
 */
export const handleSpecificParamsByQr = ({ key, paramsData, productsData }) => {
  switch (key) {
    case 'categoryQr':
      const {
        category: { params: categoryParams },
      } = paramsData;

      const categoryParamUrl = categoryParams.find((param) => param.type == 'product_url');
      const categoryParamTitle = categoryParams.find(
        (param) => param.type == 'product_detail_title_text',
      );
      const categoryParamSubtitle = categoryParams.find(
        (param) => param.type == 'product_detail_desc_text',
      );
      const categoryParamDescription = categoryParams.find(
        (param) => param.type == 'product_category_desc_text',
      );
      const categoryParamImage = categoryParams.find(
        (param) => param.type == 'product_category_img',
      );
      // Hide subtitle text if it is not provided.
      if (!categoryParamSubtitle || !categoryParamSubtitle.value) {
        $('#qr-container .product-info-wrapper').addClass('passive');
      }

      updateQrPage({
        productImg: categoryParamImage && categoryParamImage.value,
        productTitle: categoryParamTitle && categoryParamTitle.value,
        productInfo: categoryParamSubtitle && categoryParamSubtitle.value,
        productDesc: categoryParamDescription && categoryParamDescription.value,
        productUrl: categoryParamUrl && categoryParamUrl.value,
      });
      break;
    case 'seriesQr':
      const {
        series: { params: seriesParams },
      } = paramsData;

      const seriesParamUrl = seriesParams.find((param) => param.type == 'redirect_url');
      const seriesyParamTitle = seriesParams.find(
        (param) => param.type == 'product_detail_title_text',
      );
      const seriesParamSubtitle = seriesParams.find(
        (param) => param.type == 'product_detail_desc_text',
      );
      const seriesParamDescription = seriesParams.find(
        (param) => param.type == 'product_series_desc_text',
      );
      const seriesParamImage = seriesParams.find((param) => param.type == 'product_series_img');
      // Hide subtitle text if it is not provided.
      if (!seriesParamSubtitle || !seriesParamSubtitle.value) {
        $('#qr-container .product-info-wrapper').addClass('passive');
      }

      updateQrPage({
        productImg: seriesParamImage && seriesParamImage.value,
        productTitle: seriesyParamTitle && seriesyParamTitle.value,
        productInfo: seriesParamSubtitle && seriesParamSubtitle.value,
        productDesc: seriesParamDescription && seriesParamDescription.value,
        productUrl: seriesParamUrl && seriesParamUrl.value,
      });
      break;
    case 'productQr':
      const productUrl = productsData.dynamic_param_ids.find(
        (param) => param.website_id == pulpo.Keys.websiteID && param.type == 'product_url',
      );

      updateQrPage({
        productImg: productsData.product_image_url,
        productTitle: productsData.name,
        productInfo: productsData.color_name,
        productDesc: productsData.description,
        productUrl: productUrl && productUrl.value,
      });
      break;
    default:
      console.warn('No proper query param has been found: ', key);
      break;
  }
};

/**
 * Modify DOM elements in QR Page based on the QR params.
 * Sends log info when "buy button" is clicked. Hides the button if no url exists.
 * @param {string} productImg - QR specific image.
 * @param {string} productTitle - QR specific product title.
 * @param {string} productInfo - QR specific secondary title.
 * @param {string} productUrl - QR specific link of the product.
 * @param {HTMLElement} productDesc - HTML elements set in CMS.
 */
const updateQrPage = ({ productImg, productTitle, productInfo, productUrl, productDesc }) => {
  $('.qr-modal .product-img').attr('src', productImg);
  $('.qr-modal .product-title').text(productTitle);
  $('.qr-modal .product-info').text(productInfo);
  $('.qr-modal .description').html('').append(productDesc);
  $('.qr-modal .buy-btn').click(() => {
    const qrLogID = $('.qr_log_id').val();
    $.ajax({
      type: 'POST',
      url: '/engine/v0/qr_data_collect',
      dataType: 'json',
      data: {
        log_id: qrLogID,
        action_type: 'product_url',
      },
    });
    window.open(productUrl, '_blank');
  });
  if (!productUrl) {
    $('.qr-modal .buy-btn').addClass('passive');
  }
};

/**
 * @param {string} activeColorID - Unique ID of product.
 * @param {Array} products - Products list.
 * @returns {string|null} - Deep link value of the product or null.
 */
export const getDeepLinkValue = (activeColorID, products) => {
  const matchedProduct = products.find((product) => product.id == activeColorID);
  if (!matchedProduct) return;

  const deepLink = matchedProduct.dynamic_param_ids.find(
    (param) => param.website_id == pulpo.Keys.websiteID && param.type == 'deep_link',
  );
  return deepLink?.value || null;
};

/**
 * Record "Go to Product" action to the logs, then redirect user to the given product url.
 * Deep link handles pushing the record to the GTM in mobile apps.
 * @param {string} activeColorID - Unique ID of product.
 * @param {Array} products - Products list.
 */
export const goProductAction = ({
  activeColorID,
  products,
  activeMakeupMode = SINGLE_MAKEUP_MODE,
}) => {
  let filteredProducts = products.filter((product) => product.id == activeColorID);
  let productURL = filteredProducts[0].dynamic_param_ids.find(
    (param) => param.website_id == pulpo.Keys.websiteID && param.type == 'product_url',
  );
  let deepLink = filteredProducts[0].dynamic_param_ids.find(
    (param) => param.website_id == pulpo.Keys.websiteID && param.type == 'deep_link',
  );
  const [brandName, categoryName] = filteredProducts[0].categ_id[1].split('/');

  addCountlyEvent({
    segmentation: {
      product_id: activeColorID,
      [activeMakeupMode]: activeColorID,
    },
    key: CountlyMethods.GO_TO_PRODUCT.key,
  });

  sendGtmGoToProductEvent(filteredProducts[0]);
  sendCollectLog({ filteredProducts: filteredProducts, actionType: CollectActions.GO_TO_PRODUCT });

  window.parent.postMessage(
    {
      action: 'go_product_link_click',
      category_name: categoryName,
      brand_name: brandName,
      product_name: filteredProducts[0].name,
      color_name: filteredProducts[0].color_name,
      product_desc: filteredProducts[0].description,
      product_code: filteredProducts[0].uid,
      pulpo_id: filteredProducts[0].id,
    },
    '*',
  );

  if (pulpo.Keys.mobileDeepLinkToggle) {
    const { key, value } = deepLink;

    sendEventToMobileApps({ key, value });
    window.parent.postMessage(
      {
        event_id: key,
        data: value,
        category_name: categoryName,
        brand_name: brandName,
        product_name: filteredProducts[0].name,
        color_name: filteredProducts[0].color_name,
        product_desc: filteredProducts[0].description,
        product_code: filteredProducts[0].uid,
        pulpo_id: filteredProducts[0].id,
      },
      '*',
    );
    return;
  }

  if (!productURL || !productURL.value) return;
  const urlValue = productURL.value;
  window.open(urlValue, '_blank');
};

/**
 * @param {Object} selectedProduct - Selected product data.
 */
export const sendGtmAddToCartEvent = (selectedProduct) => {
  if (!window.dataLayer) return;

  // Legacy GTM event, will be removed if not used by any current partner.
  window.dataLayer.push({
    event: 'gtm.click',
    key: getGTMAddToCartKey(),
    websiteID: pulpo.Keys.websiteID,
    productID: selectedProduct.pulpo_qr,
  });

  const gtmAddToCartParam = selectedProduct.dynamic_param_ids.find(
    (param) => param.website_id == pulpo.Keys.websiteID && param.type == 'gtm_add_to_cart',
  );
  if (!gtmAddToCartParam) return;
  // TODO(emrerdem1): Implement "add to cart" specific GTM event when it's ready.
};

/**
 * @param {Object} selectedProduct - Selected product data.
 */
export const sendGtmGoToProductEvent = (selectedProduct) => {
  if (!window.dataLayer) return;

  // Legacy GTM event, will be removed if not used by any current partner.
  window.dataLayer.push({
    event: 'gtm.click',
    key: pulpo.Keys.gtmGoToProductKey || CollectActions.GO_TO_PRODUCT,
    websiteID: pulpo.Keys.websiteID,
    productID: selectedProduct.pulpo_qr,
  });

  const gtmGoToProductParam = selectedProduct.dynamic_param_ids.find(
    (param) => param.website_id == pulpo.Keys.websiteID && param.type == 'gtm_go_to_product',
  );
  if (!gtmGoToProductParam) return;

  const formattedEventKey = formatCustomGtmEventKey(gtmGoToProductParam.value);
  const getCustomGtmEvent = CustomGtmEvents[formattedEventKey];
  if (!getCustomGtmEvent) return;

  window.dataLayer.push(getCustomGtmEvent(selectedProduct));
};

/**
 * @param {string|null} value - Value of the custom GTM event.
 */
const formatCustomGtmEventKey = (value) => value.toString().toUpperCase();

/**
 * Custom GTM events by website specific GTM event keys.
 * Event keys have to be in uppercase and match with the GTM value in dynamic_param_ids.
 * @param {Object} product - Selected product data.
 * @returns {Object} - Custom GTM event object.
 */
const CustomGtmEvents = {
  FLORMAR_GO_TO_PRODUCT: (product) => ({
    event: 'pulpoAR',
    eventAction: 'Ürüne Git',
    eventLabel: product.name || product.uid,
    ecommerce: {
      items: [
        {
          item_id: product.uid,
          item_name: product.name,
          item_category: product.categ_id[1],
        },
      ],
    },
  }),
};

/**
 * Value of the field might be "false" as string, so it should be checked with value as well.
 * @returns {boolean} - Whether has a valid add to cart key or not.
 */
const hasCustomGTMCartKey = () =>
  pulpo.Keys.gtmAddToCartKey && pulpo.Keys.gtmAddToCartKey != 'false';

/**
 * Get add to cart key set for the website to push to data layer of GTM.
 * @returns {string} - Default or specific add to cart key per website.
 */
const getGTMAddToCartKey = () => {
  if (hasCustomGTMCartKey()) {
    return pulpo.Keys.gtmAddToCartKey;
  }
  return 'add_to_cart';
};

const FlormarAppMessageKeys = {
  ADD_TO_CART: 'addToCart',
  GO_TO_PRODUCT: 'goToProduct',
};

/**
 * Certain postMessage is needed for Flormar partner to receive "Add to Cart" event on their website.
 * This message will not be received by Flormar itself, but by our connector iframe (FlormarVTO).
 * @param {string} productAddToCartID - Add to cart value set for Flormar product in mobile.
 */
const sendFlormarAddToCartInfo = (productAddToCartID) => {
  if ($('.template_type').val() !== 'flormar' || !productAddToCartID) return;

  window.parent.postMessage(
    {
      event_id: FlormarAppMessageKeys.ADD_TO_CART,
      data: {
        prdCode: parseInt(productAddToCartID),
      },
    },
    '*',
  );
};

/**
 * Certain postMessage is needed for Flormar partner to receive "Go to Product" event on their website.
 * This message will not be received by Flormar itself, but by our connector iframe (FlormarVTO).
 * @param {string} deepLinkValue - Deep link value set for Flormar product in mobile.
 */
const sendFlormarMobileGoToProductInfo = (deepLinkValue) => {
  if ($('.template_type').val() !== 'flormar' || !deepLinkValue) return;

  window.parent.postMessage(
    {
      event_id: FlormarAppMessageKeys.GO_TO_PRODUCT,
      data: {
        deepLink: deepLinkValue,
      },
    },
    '*',
  );
};

export const isFlormarMobileApp = () =>
  document.referrer && document.referrer.includes('flormarvtoapp');

/**
 * Find product by ID and record "Add to Cart" action to the logs.
 * @param {string} activeColorID - Unique ID of product.
 * @param {Array} products - Products list.
 * @param {string} [activeMakeupMode=SINGLE_MAKEUP_MODE] - Active makeup mode.
 */
export const flormarAppAddToCart = ({
  activeColorID,
  products,
  activeMakeupMode = SINGLE_MAKEUP_MODE,
}) => {
  const matchedProduct = products.find((product) => product.id == activeColorID);
  const cartAction = matchedProduct.dynamic_param_ids.find(
    (param) => param.website_id == pulpo.Keys.websiteID && param.type === 'cart_action',
  );
  if (!cartAction) return;

  sendFlormarAddToCartInfo(cartAction.value);
  addCountlyEvent({
    segmentation: {
      product_id: activeColorID,
      [activeMakeupMode]: activeColorID,
    },
    key: CountlyMethods.ADD_TO_CART.key,
  });
  sendCollectLog({ filteredProducts: [matchedProduct], actionType: CollectActions.ADD_TO_CART });
};

/**
 * Find product by ID and record "Add to Cart" action to the logs.
 * @param {string} activeColorID - Unique ID of product.
 * @param {Array} products - Products list.
 * @param {string} [activeMakeupMode=SINGLE_MAKEUP_MODE] - Active makeup mode.
 */
export const flormarAppGoToProduct = ({
  activeColorID,
  products,
  activeMakeupMode = SINGLE_MAKEUP_MODE,
}) => {
  const matchedProduct = products.find((product) => product.id == activeColorID);
  const deepLink = matchedProduct.dynamic_param_ids.find(
    (param) => param.website_id == pulpo.Keys.websiteID && param.type === 'deep_link',
  );
  sendGtmGoToProductEvent(matchedProduct);
  if (!deepLink) return;

  sendFlormarMobileGoToProductInfo(deepLink.value || 'No deep link has been set for the product.');
  addCountlyEvent({
    segmentation: {
      product_id: activeColorID,
      [activeMakeupMode]: activeColorID,
    },
    key: CountlyMethods.GO_TO_PRODUCT.key,
  });
  sendCollectLog({ filteredProducts: [matchedProduct], actionType: CollectActions.GO_TO_PRODUCT });
};

/**
 * Send events to mobile apps, such as add_to_cart and go_to_product.
 * @param {string} key - event_id key set by partner.
 * @param {string} value - Specific product value for the action.
 */
export const sendEventToMobileApps = ({ key, value }) => {
  try {
    if (!key || !value) return;

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('event_id:' + key + '|' + 'data:' + value);
    }

    if (window.JSBridge && window.JSBridge.postMessage) {
      window.JSBridge.postMessage('event_id:' + key + ' | ' + 'data:' + value);
    }

    if (window.webkit) {
      window.webkit.messageHandlers.jsHandler.postMessage({
        message: 'event_id:' + key + ' | ' + 'data:' + value,
      });
    }
  } catch (err) {
    console.log(`Could not send the cart events to the mobile apps: ${err}`);
  }
};

/**
 * Find product by ID and record "Add to Cart" action to the logs.
 * Deep link handles pushing the record to the GTM in mobile apps.
 * @param {string} activeColorID - Unique ID of product.
 * @param {Array} products - Products list.
 */
export const addCartAction = ({
  activeColorID,
  products,
  activeMakeupMode = SINGLE_MAKEUP_MODE,
}) => {
  let filteredProducts = products.filter((product) => product.id == activeColorID);
  let cartAction = filteredProducts[0].dynamic_param_ids.find(
    (param) => param.website_id == pulpo.Keys.websiteID && param.type == 'cart_action',
  );

  addCountlyEvent({
    segmentation: {
      product_id: activeColorID,
      [activeMakeupMode]: activeColorID,
    },
    key: CountlyMethods.ADD_TO_CART.key,
  });

  sendGtmAddToCartEvent(filteredProducts[0]);
  sendCollectLog({ filteredProducts: filteredProducts, actionType: CollectActions.ADD_TO_CART });

  const { key, value } = cartAction;
  sendFlormarAddToCartInfo(value);
  sendEventToMobileApps({ key, value });

  const [brandName, categoryName] = filteredProducts[0].categ_id[1].split('/');
  window.parent.postMessage(
    {
      event_id: key,
      data: value,
      category_name: categoryName,
      brand_name: brandName,
      product_name: filteredProducts[0].name,
      color_name: filteredProducts[0].color_name,
      product_desc: filteredProducts[0].description,
      product_code: filteredProducts[0].uid,
      pulpo_id: filteredProducts[0].id,
    },
    '*',
  );

  window.parent.postMessage(
    {
      hitType: 'event',
      event: 'add_to_cart',
      category_name: categoryName,
      brand_name: brandName,
      product_name: filteredProducts[0].name,
      color_name: filteredProducts[0].color_name,
      product_desc: filteredProducts[0].description,
      product_code: filteredProducts[0].uid,
      pulpo_id: filteredProducts[0].id,
    },
    '*',
  );
};

export const createProductQR = (allBarcodes) => {
  const combinedText = allBarcodes.join(' ');
  QRCode.toDataURL(combinedText)
    .then((qrCode) => {
      $('.qr-popup').css('display', 'flex');
      $('.qrCodeImage').attr('src', qrCode);
    })
    .catch((error) => {
      console.error(error);
    });
};

/**
 * Update the appearance of "Go to Product" button dynamically.
 * @param {string} selector - jQuery selector of the element.
 */
export const updateProductButton = ({ selector }) => {
  $(selector).css({
    'background-color': pulpo.allTemplateValues.buttons_background_color,
    'border-color': pulpo.allTemplateValues.buttons_border_color,
    color: pulpo.allTemplateValues.buttons_text_color,
  });

  if (pulpo.allTemplateValues.buttons_hover_action_color) {
    const initialTextColor = $(selector).css('color');
    const initialBorderColor = $(selector).css('border-color');
    $(selector).hover(
      function () {
        $(this).css({
          color: pulpo.allTemplateValues.buttons_hover_action_color,
          'border-color': pulpo.allTemplateValues.buttons_hover_action_color,
        });
      },
      function () {
        $(this).css({
          color: initialTextColor,
          'border-color': initialBorderColor,
        });
      },
    );
  }
};

/**
 * Sends postMessage to clear makeup of the plugin by active category name.
 * Pluginv1 delete all makeups regardless of category name, but we need to know
 * whether it is Nail plugin or not by the name of category for now.
 * @param {string} activeCategoryName - Current active category name.
 */
export const removeMakeup = (activeCategoryName = '') => {
  if (activeCategoryName == 'Nailpolish' && document.getElementById('nailpolishView')) {
    nailpolishView.contentWindow.window.postMessage(
      JSON.stringify({
        removeProduct: '',
      }),
      '*',
    );
    return;
  }

  makeupView.contentWindow.window.postMessage(
    JSON.stringify({
      removeProduct: activeCategoryName,
    }),
    '*',
  );
};

/**
 * Assign two different category products into one category
 * if combineParams contain the selected category name.
 * @param {string} categoryName - Selected category name.
 * @param {string} productCategoryName - Name of the category in products loop.
 * @param {Array} combineParams - Array of key and value objects,
 *     consisting of two category names concatenated by underscore -> ['combine_categories': 'A_B']
 * @returns {boolean} - Indicates whether combineParams or product has the category name or not.
 */
export const getCombinedCategoryProducts = ({
  categoryName,
  productCategoryName,
  combineParams,
}) => {
  const groupKeys = combineParams.find((param) => {
    return MultiCategoryKeys[param.value].split('_').includes(categoryName);
  });

  if (!groupKeys) {
    return productCategoryName.includes(categoryName);
  }
  return groupKeys.value.split('_').includes(productCategoryName);
};

/**
 * Sends a post message to switch plugin types for Plugin v2.
 * @param {boolean} isNailSwitch - Whether it should enable nail or makeup.
 *     Plugin would switch to the makeup if given param is false.
 */
export const swichPluginTypes = (isNailSwitch) => {
  makeupView.contentWindow.window.postMessage(
    JSON.stringify({
      switchPlugin: { isNailSwitch },
    }),
    '*',
  );
  if (document.getElementById('nailpolishView')) {
    // This will be deleted after Plugin v2 implementation.
    // Only one iframe is enough for Plugin v2.
    nailpolishView.contentWindow.window.postMessage(
      JSON.stringify({
        switchPlugin: { isNailSwitch },
      }),
      '*',
    );
  }
};

/**
 * Sends postMessage to clear makeup and reset active product of Plugin v2.
 */
export const removeProduct = () => {
  makeupView.contentWindow.window.postMessage(
    JSON.stringify({
      removeProduct: true,
    }),
    '*',
  );
  if (document.getElementById('nailpolishView')) {
    // This will be deleted after Plugin v2 implementation.
    // Only one iframe is enough for Plugin v2.
    nailpolishView.contentWindow.window.postMessage(
      JSON.stringify({
        removeProduct: true,
      }),
      '*',
    );
  }
};

/**
 * Creates carousel out of looks types in Owl.
 */
export const makeLooksTypeOwl = () => {
  $('.looks-types').owlCarousel({
    loop: false,
    margin: 17,
    dots: false,
    nav: true,
    navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
    autoWidth: true,
    responsive: {
      1400: {
        margin: 20,
      },
      576: {
        margin: 14,
      },
    },
  });
};

/**
 * Creates carousel out of looks categories in Slick.
 * @param {string} selector - Class name of slick-carousel element.
 */
export const makeLooksCategorySlick = (selector) => {
  // Do not try to create new Slick if it already exists.
  if ($(selector).hasClass('slick-slider')) return;

  $(selector).slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    nextArrow: '<i class="fas fa-chevron-right"></i>',
    prevArrow: '<i class="fas fa-chevron-left"></i>',
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 998,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 5.2,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 4.3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3.7,
        },
      },
      {
        breakpoint: 470,
        settings: {
          slidesToShow: 3.2,
        },
      },
    ],
  });
};

/**
 * Creates carousel out of looks products in Slick.
 */
export const makeLooksProductSlick = () => {
  $('.products-list').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    nextArrow: '<i class="fas fa-chevron-right"></i>',
    prevArrow: '<i class="fas fa-chevron-left"></i>',
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2.6,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1.7,
        },
      },
      {
        breakpoint: 998,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 3.6,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3.2,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.4,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 460,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 410,
        settings: {
          slidesToShow: 1.9,
        },
      },
    ],
  });
};

/**
 * Creates carousel out of collection products in Slick for Looks Template.
 */
export const makeCollectionProductSlick = () => {
  $('.products').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    nextArrow: '<i class="fas fa-chevron-right"></i>',
    prevArrow: '<i class="fas fa-chevron-left"></i>',
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2.6,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 998,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 3.6,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3.2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.6,
        },
      },
    ],
  });
};

/**
 * Toggle selected section and update their text and Slick carousels.
 * @param {string} section - Collapse jQuery selector to trigger click event on.
 * @param {string} title - Title element jQuery selector to update its class.
 * @param {string} innerContainer - Inner container of li elements jQuery selector.
 */
export const toggleCollapseSection = ({ section, title, innerContainer }) => {
  $(section).click(function () {
    if ($(section).hasClass('collapsed')) {
      $(title).removeClass('closed collapsed');
      $(this).find('.toggle-button').html("<i class='fas fa-chevron-up'></i>");
      $(innerContainer).slideDown(300);
      // We need to refresh the slick after changing display from none to block.
      if ($(innerContainer).hasClass('slick-slider')) {
        $(innerContainer).slick('refresh');
      }
    } else {
      $(title).addClass('collapsed');
      $(this).find('.toggle-button').html("<i class='fas fa-chevron-down'></i>");
      $(innerContainer).slideUp(300);
    }
  });
};

/**
 * User might have hidden next section, it should be opened
 *     after selection previous section all the time.
 * @param {string} nextSectionSelector - Section container to show next.
 */
export const openNextSection = (nextSectionSelector) => {
  // It is already opened, no need to trigger again.
  if (!$(nextSectionSelector).hasClass('collapsed')) return;

  $(nextSectionSelector).click();
};

let currentSectionTimeoutId;
/**
 * Close the current carousel section in mobile to make more room in viewport.
 * @param {string} currentSectionSelector - Current section container to close.
 * @param {number} [delay=200] - Delay in milliseconds.
 */
export const closeCurrentSectionInMobile = (currentSectionSelector, delay = 200) => {
  if (!checkIsMobile()) return;

  clearTimeout(currentSectionTimeoutId);
  currentSectionTimeoutId = setTimeout(() => {
    $(currentSectionSelector).click();
  }, delay);
};

/**
 * Removing empty categories if category doesn't have any product,
 * and removing element of empty category.
 * @param {Array} categories - Categories array.
 * @param {Array} products - Products array.
 */
export const getValidCategoryList = (categories, products) => {
  let uniqueProductCategories = products
    .map((product) => product.categ_id[1].split('/')[1].trim())
    .filter((product, index, productList) => productList.indexOf(product) === index);

  return categories.filter((category) => {
    if (!uniqueProductCategories.includes(category.name)) {
      $(`.category[data-name=${category.name}]`).remove();
      return false;
    }
    return true;
  });
};

/**
 * Add events to countly.
 * @param {object} [segmentation=false] - Segmentation to group events under event id.
 * @param {string} key - Event id that needs to be written to countly.
 */
export function addCountlyEvent({ segmentation = false, key }) {
  Countly.q.push([
    'add_event',
    {
      key: key,
      count: 1,
      segmentation: segmentation,
    },
  ]);
}

/**
 * It is used to write logs to odoo.
 * @param {object} filteredProducts - Returns active product information..
 * @param {string} actionType - Returns the desired action type to log.
 */
export function sendCollectLog({ filteredProducts, actionType }) {
  $.ajax({
    type: 'POST',
    url: '/engine/v0/collect',
    data: {
      websiteID: pulpo.Keys.websiteID,
      productID: filteredProducts[0].id,
      action: actionType,
      apiKey: pulpo.Keys.apiKey,
    },
  });
}

/**
 * Save log agreement indicating user has accepted the KVKK terms.
 */
export async function saveLogAgreement() {
  await $.ajax({
    type: 'POST',
    url: '/engine/v0/log_agreement',
    data: {
      websiteID: pulpo.Keys.websiteID,
      apiKey: pulpo.Keys.apiKey,
    },
  });
}

/**
 * It will be open the product container.
 * @param {array} productList - Products array.
 * @param {string} categoryName - Active category name.
 * @param {array} combineCategoriesParams - Combine categories params.
 */
export const setProductsContainer = ({ productList, categoryName, combineCategoriesParams }) => {
  const categoryProducts = productList.filter((product) => {
    // We need to check combined categories when params exist.
    if (combineCategoriesParams.length) {
      return getCombinedCategoryProducts({
        categoryName,
        productCategoryName: product.categ_id[1].split('/')[1].trim(),
        combineParams: combineCategoriesParams,
      });
    }
    return product.categ_id[1].includes(categoryName);
  });

  assignCategoryProducts({
    container: '.products',
    categoryProducts,
  });

  owlConfigs.makeProductsCarousel();

  $('.category-title.category-section').addClass('closed');
  setTimeout(() => openNextSection('.product-collapse'), 300);
  closeCurrentSectionInMobile('.category-section');
};

/**
 * Set the plugin type according to the category.
 * @param {boolean} isNail - Active category name is nail or not.
 */
export const setPlugin = ({ isNail }) => {
  if (isNail) {
    $('#nailpolishView').removeClass('hidden');
    $('#makeupView').addClass('hidden');
    swichPluginTypes(true);
    return;
  }
  $('#makeupView').removeClass('hidden');
  $('#nailpolishView').addClass('hidden');
  swichPluginTypes(false);
};

/**
 * Partners have an issue with nested scrolling in iframe.
 * This function will be inform parent about height and its changes.
 * @param {string} height - Height of the iframe.
 */
const messageParentAboutHeight = (height) => {
  window.parent.postMessage({ event: 'template_height_changed', height }, '*');
};

/**
 * Observe the main container element height and inform parent about changes.
 */
export const observeContainerHeight = () => {
  try {
    const TEMPLATE_CONTAINER = '#container',
      RESIZE_TIMEOUT = 10;
    let resizedTemplateHeight, timerId;

    new ResizeObserver((entries) => {
      const container = entries[0].contentRect;
      if (resizedTemplateHeight === container.height) return;
      timerId && clearTimeout(timerId);
      // Height might be 0 when the template is loaded for the first time, use fallback height.
      resizedTemplateHeight = container.height || $(TEMPLATE_CONTAINER).height();
      timerId = setTimeout(
        () => messageParentAboutHeight(Math.ceil(resizedTemplateHeight)),
        RESIZE_TIMEOUT,
      );
    }).observe($(TEMPLATE_CONTAINER)[0]);
  } catch (error) {
    console.error('Error while observing container height', error.message);
  }
};

/**
 * Observe the main container element width and invoke callback on its changes.
 * @param {function} onResize - Callback function to invoke on resize.
 */
export const observeWindowWidth = ({ onResize }) => {
  try {
    const LAYOUT_SHIFT_THRESHOLD = 50,
      RESIZE_TIMEOUT = 400;
    let resizedTemplateWidth, timerId;

    new ResizeObserver((entries) => {
      const container = entries[0].contentRect;
      const diff = Math.abs(resizedTemplateWidth - container.width);

      if (resizedTemplateWidth && diff < LAYOUT_SHIFT_THRESHOLD) return;
      timerId && clearTimeout(timerId);
      // Width might be 0 when the template is loaded for the first time, use fallback width.
      const currentWidth = container.width || $(window).width();
      timerId = setTimeout(() => {
        onResize();
        resizedTemplateWidth = currentWidth;
      }, RESIZE_TIMEOUT);
    }).observe(document.body);
  } catch (error) {
    console.error('Error while observing container width', error.message);
  }
};

/**
 * Check if the image is loaded or not. (https://stackoverflow.com/a/22530730)
 * @param {string} imgClass - Image class to check loading status.
 * @param {Function} onSuccess - Callback function to run when image is loaded.
 * @param {Function} onError - Callback function to run when image is not loaded.
 */
export const onImgLoaded = ({ imgClass, onSuccess, onError }) => {
  $(imgClass)
    .on('load', function () {
      onSuccess();
      // Remove event listener.
      $(this).off();
    })
    .on('error', function () {
      onError();
      $(this).off();
    })
    .each(function () {
      if (this.complete) {
        $(this).load();
      } else if (this.error) {
        $(this).error();
      }
    });
};

const PLUGIN_FULL_WITH_BREAKPOINT = 620;
/**
 * Gets buffer value to add on top of plugin height.
 * @param {boolean} isSmallBuffer - Whether to add a small buffer value in desktop.
 * @returns {number} - Value to add on plugin height.
 */
export const getPluginBufferSize = (isSmallBuffer = false) => {
  // Plugin width is expanded to full width, no need to have buffer.
  if ($(window).width() <= PLUGIN_FULL_WITH_BREAKPOINT) return 0;
  // Add slight buffer to narrow screens.
  if ($(window).width() <= helpers.Breakpoints.WIDE_TABLET) return 50;
  return isSmallBuffer ? 90 : 170;
};

/** Template fields update from external source.
 * @param {string} fieldValue - Value to update.
 * @param {string} fieldName - Field name to update.
 */
export const updateTemplateFieldFromExternal = (fieldValue, fieldName) => {
  switch (TemplateFields[fieldName].type) {
    case TemplateFieldTypes.TEXT:
      textUpdate(TemplateFields[fieldName].classname, fieldValue);
      break;
    case TemplateFieldTypes.COLOR:
      colorUpdate(TemplateFields[fieldName].classname, fieldValue, TemplateFields[fieldName].style);
      break;
    case TemplateFieldTypes.HOVER:
      hoverUpdate(TemplateFields[fieldName].classname, fieldValue);
      break;
    case TemplateFieldTypes.SWITCH_ARROW:
      switchArrowUpdate(TemplateFields[fieldName].classname, fieldValue);
      break;
    case TemplateFieldTypes.SWITCH_BRAND:
      switchBrandUpdate(
        TemplateFields[fieldName].mainClassName,
        TemplateFields[fieldName].secondClassName,
        fieldValue,
      );
      break;
    case TemplateFieldTypes.CATEGORIES:
      categoriesUpdate(TemplateFields[fieldName].classname, fieldValue);
      break;
  }
};

/**
 * Update text field.
 * @param {string} classname - Class name of the element to update.
 * @param {string} fieldValue - Value to update.
 * @returns {void}
 */
const textUpdate = (classname, fieldValue) => {
  $(classname).text(fieldValue);
};

/**
 * Update color field.
 * @param {string} classname - Class name of the element to update.
 * @param {string} fieldValue - Value to update.
 * @param {string} styleProperty - Style property to update.
 * @returns {void}
 */
const colorUpdate = (classname, fieldValue, styleProperty) => {
  if (!$(classname).length) {
    const styleTag = $('<style>').appendTo('head');
    styleTag.text(`${classname} { ${styleProperty}: ${fieldValue} !important; }}`);
    return;
  }
  $(classname).css(styleProperty, fieldValue);
};

/**
 * Update hover field.
 * @param {string} classname - Class name of the element to update.
 * @param {string} fieldValue - Value to update.
 * @returns {void}
 */
const hoverUpdate = (classname, fieldValue) => {
  const initialTextColor = $(classname).css(TemplateColorFieldPropertTypes.COLOR);
  const initialBorderColor = $(classname).css(TemplateColorFieldPropertTypes.BORDER_COLOR);
  $(classname).hover(
    function () {
      $(this).css({
        [TemplateColorFieldPropertTypes.COLOR]: fieldValue,
        [TemplateColorFieldPropertTypes.BORDER_COLOR]: fieldValue,
      });
    },
    function () {
      $(this).css({
        [TemplateColorFieldPropertTypes.COLOR]: initialTextColor,
        [TemplateColorFieldPropertTypes.BORDER_COLOR]: initialBorderColor,
      });
    },
  );
};

/**
 * Update switch brand field.
 * @param {string} mainClassName - Class name of the element to update.
 * @param {string} secondClassName - Class name of the element to update.
 * @param {string} fieldValue - Value to update.
 * @returns {void}
 */
const switchBrandUpdate = (mainClassName, secondClassName, fieldValue) => {
  if (fieldValue) {
    $(mainClassName).show();
    $(secondClassName).hide();
    return;
  }
  if (pulpo.isBrandEnabled) {
    $(mainClassName).hide();
    $(secondClassName).show();
  }
};

/**
 * Update switch arrow field.
 * @param {string} classname - Class name of the element to update.
 * @param {string} fieldValue - Value to update.
 * @returns {void}
 */
const switchArrowUpdate = (classname, fieldValue) => {
  if (fieldValue) {
    $(classname).addClass('arrow-enable');
    return;
  }
  $(classname).removeClass('arrow-enable');
};

/**
 * Update categories field.
 * @param {string} classname - Class name of the element to update.
 * @param {string} fieldValue - Value to update.
 * @returns {void}
 */
const categoriesUpdate = (classname, fieldValue) => {
  Store.categories = fieldValue;
  destroyExistingSlick(classname);
  assignCategories({ container: classname, categoryList: fieldValue });
  makeCategoriesSlick();
};

export const TemplateEvents = {
  BRAND_SELECTED: 'brand_selected',
  CATEGORY_SELECTED: 'category_selected',
  PRODUCT_SELECTED: 'product_selected',
  PRODUCT_VARIANT_SELECTED: 'product_variant_selected',
};

export const PluginEvents = {
  KVKK_CHECKED: 'kvkk_checked',
  TAKE_PHOTO: 'take_photo_clicked',
  CHOOSE_MODEL: 'choose_model_clicked',
  SELECT_SPECIFIC_MODEL: 'model_selection_clicked',
  FACE_NOT_FOUND: 'face_not_found',
  MAKEUP_APPLIED: 'makeup_applied',
  NAIL_APPLIED: 'nailpolish_applied',
  INITIALIZED: 'initialized',
  LIVE_CAMERA: 'live_camera_clicked',
  LIVE_CAMERA_READY: 'live_camera_ready',
};

export const LegacyPluginEvents = {
  KVKK_CHECKED: 'kvkk_checked_message',
  TAKE_PHOTO: 'clickedTakePhotoButton',
  CHOOSE_MODEL: 'clickedChooseModelButton',
  FACE_NOT_FOUND: 'faceNotFoundError',
};

export const UserInteraction = {
  SELECT_SPECIFIC_MODEL: 'model_selection',
  CHOOSE_MODEL: 'choose_model',
  TAKE_PHOTO: 'take_photo',
  LIVE_CAMERA: 'live_camera',
};
